import { Component, OnInit, Input } from '@angular/core';
import { NguCarousel } from '@ngu/carousel';

@Component({
  selector: 'app-about-carousel',
  templateUrl: './about-carousel.component.html',
  styleUrls: ['./about-carousel.component.scss']
})
export class AboutCarouselComponent implements OnInit {
  @Input('backgroundGray') public backgroundGray;
  
  public carouselOptions: NguCarousel;
  public automations = [{
    photo: 'assets/images/zz/about-1.jpg',
    text: `Создание моделей мебели с помощью САПР и объединение созданных моделей в коллекции. Сложность моделей варьируется от статических до параметризованных с анимацией работы механизмов.`,
    title: '1',
  }, {
    photo: 'assets/images/zz/about-2.jpg',
    text: `Визуализация моделей мебели для отображения конечному клиенту с возможностью формирования заказа, детальной спецификацией и калькуляцией.`,
    title: '2',
  }, {
    photo: 'assets/images/zz/about-3.jpg',
    text: `Автоматизация работы мебельных салонов с подбором интерьера и мебели по запросу клиента.`,
    title: '3',
  }, {
    photo: 'assets/images/zz/about-4.jpg',
    text: `Интеграция с производством. Представление сформированных заказов в виде программ для станков с ЧПУ.`,
    title: '4',
  },]
  constructor() { }

  ngOnInit() {
    this.carouselOptions = {
      grid: { xs: 1, sm: 2, md: 3, lg: 3, all: 0 },
      slide: 2,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: true
    }
  }

}
